import type { ReactNode } from 'react';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import { I18N_TYPE, NODE_TYPE, type I18nDisplayable, type NodeDisplayable } from './types';

export const ofI18n = (content: MessageDescriptor): I18nDisplayable => ({
	type: I18N_TYPE,
	content,
});

export const ofNode = (content: ReactNode): NodeDisplayable => ({
	type: NODE_TYPE,
	content,
});
